var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "WishList",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #WishList .cls-1 {\n        fill: #ffe200;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1093.436 -344.431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_588",
    "data-name": "Pfad 588",
    className: "cls-1",
    d: "M1113.436,344.431a20,20,0,1,0,20,20A20.022,20.022,0,0,0,1113.436,344.431Zm0,37.849a17.849,17.849,0,1,1,17.849-17.849A17.87,17.87,0,0,1,1113.436,382.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1694",
    "data-name": "Rechteck 1694",
    className: "cls-1",
    width: 7.961,
    height: 1.977,
    transform: "translate(1111.155 360.274)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1695",
    "data-name": "Rechteck 1695",
    className: "cls-1",
    width: 1.935,
    height: 1.977,
    transform: "translate(1107.432 360.274)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1696",
    "data-name": "Rechteck 1696",
    className: "cls-1",
    width: 7.961,
    height: 1.977,
    transform: "translate(1111.155 363.801)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1697",
    "data-name": "Rechteck 1697",
    className: "cls-1",
    width: 1.935,
    height: 1.977,
    transform: "translate(1107.432 363.801)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1698",
    "data-name": "Rechteck 1698",
    className: "cls-1",
    width: 7.961,
    height: 1.977,
    transform: "translate(1111.155 367.329)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1699",
    "data-name": "Rechteck 1699",
    className: "cls-1",
    width: 1.935,
    height: 1.977,
    transform: "translate(1107.432 367.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_589",
    "data-name": "Pfad 589",
    className: "cls-1",
    d: "M1124.257,358.431l0-.008,0,0a.687.687,0,0,0-.047-.065l-.764-.786-3.845-4.038a.645.645,0,0,0-.467-.2h-11.036a2.18,2.18,0,0,0-2.155,2.2v19.259a2.179,2.179,0,0,0,2.155,2.2h14.184a2.18,2.18,0,0,0,2.156-2.2V358.869a.637.637,0,0,0-.11-.339A.607.607,0,0,0,1124.257,358.431Zm-2.043-.272h-2.52v-2.594Zm.061,17.537h-14.184a.888.888,0,0,1-.865-.908V355.53a.888.888,0,0,1,.865-.908H1118.4V358.8a.645.645,0,0,0,.645.645h4.092v15.339A.889.889,0,0,1,1122.275,375.7Z",
    transform: "translate(-1.747 -1.244)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishList);
export default __webpack_public_path__ + "static/media/wish-list.c921c41bd22b5654ed0f43b8ad0da4d9.svg";
export { ForwardRef as ReactComponent };